import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import {
  Table,
  Td,
  Tr,
  Th,
  Tbody,
  Thead,
  Tfoot,
  Box,
} from "@chakra-ui/react";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import {  useMemo, useState } from "react";
import Pagination from "react-bootstrap/Pagination"; // Import Pagination component
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";

const InvoiceTdsInfo = ({ selectedItem,currency }) => {
  
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; 

  const tdsRc = selectedItem?.tdsApl?.tdsRc || [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = useMemo(() => tdsRc.slice(indexOfFirstItem, indexOfLastItem), [tdsRc, indexOfFirstItem, indexOfLastItem]);

  const pageCount = useMemo(() => Math.ceil(tdsRc.length / itemsPerPage), [tdsRc, itemsPerPage]);

  const totalTds = useMemo(() => {
    return currentItems.reduce((acc, record) => acc + (record?.tdsAmt || 0), 0);
  }, [currentItems])
  return (
    <>
      <Row className="info-row">
        <Col className="check-cross-mark mt-0">
          <Form.Label>
            <span
              className={
                currentItems.length
                  ? "checkmark"
                  : "crossmark"
              }
            ></span>{" "}
            Is TDS Deducted?
          </Form.Label>
        </Col>
      </Row>
      {currentItems.length ? (
        <div className="info-table">
          <Box overflowX="auto">
            <Table size="md" className="table-info" variant="striped">
              <Thead>
                <Tr>
                  <Th>No.</Th>
                  <Th>Base Amount</Th>
                  <Th>TDS Percentage (%)</Th>
                  <Th>TDS Amount</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentItems.map((item, index) => {
                  const { bsAmt, prc, tdsAmt } = item;
                  return (
                    <Tr key={index}>
                      <Td>{indexOfFirstItem + index + 1}</Td>
                      <Td>
                        <span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span>{" "}
                        {bsAmt ? formatAmountIndianRupees(Number(bsAmt)) : Number(0).toFixed(2)}
                      </Td>
                      <Td>{prc || 0} %</Td>
                      <Td>
                        <span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span>{" "}
                        {tdsAmt ? formatAmountIndianRupees(Number(tdsAmt)) : Number(0).toFixed(2)}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
              <Tfoot>
                <Tr>
                  <Th colSpan={1}>Total TDS</Th>
                  <Td></Td>
                  <Td></Td>

                  <Td colSpan={1}>
                  <span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span>{" "}
                  {formatAmountIndianRupees(totalTds || 0)}
                  </Td>
                  
                  
                </Tr>
              </Tfoot>
            </Table>
          </Box>

          {/* Pagination Component */}
          <Pagination className="justify-content-end" style={{ marginTop: '20px' }}>
            <Pagination.Prev
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            />
            {Array.from({ length: pageCount }, (_, i) => (
              <Pagination.Item
                key={i + 1}
                active={i + 1 === currentPage}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, pageCount))}
              disabled={currentPage === pageCount}
            />
          </Pagination>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default InvoiceTdsInfo;
